var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39083 1.72367C8.14084 1.47361 7.80176 1.33308 7.44816 1.33301H2.66683C2.31321 1.33301 1.97407 1.47348 1.72402 1.72353C1.47397 1.97358 1.3335 2.31272 1.3335 2.66634V7.44767C1.33357 7.80127 1.4741 8.14035 1.72416 8.39034L7.52683 14.193C7.82984 14.4941 8.23966 14.6631 8.66683 14.6631C9.094 14.6631 9.50382 14.4941 9.80683 14.193L14.1935 9.80634C14.4946 9.50333 14.6636 9.09351 14.6636 8.66634C14.6636 8.23917 14.4946 7.82935 14.1935 7.52634L8.39083 1.72367Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 5.33366C5.18393 5.33366 5.33317 5.18442 5.33317 5.00033C5.33317 4.81623 5.18393 4.66699 4.99984 4.66699C4.81574 4.66699 4.6665 4.81623 4.6665 5.00033C4.6665 5.18442 4.81574 5.33366 4.99984 5.33366Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.b79881b99c6082c35e4a00919d8eef8a.svg";
export { ForwardRef as ReactComponent };